<i18n src="../../locales/lang.json"></i18n>

<template>
  <div class="fixed-bottom container-fluid d-md-none" style="z-index:1049">
    <div v-show="selectedItem.expanded == true || (selectedItem.expanded == false && display == true && getDisplayMessage() != null)" class="speech-bubble p-2 skin" v-bind:class="getSelectedItemClass(selectedItem)" style="z-index:100">
      <div class="row">
        <div class="col-11 pl-2" v-if="selectedItem.expanded == false && display == true" style="position:relative;">
          <span class="skin nux-textcolor mb-1" v-html="getDisplayMessage()"></span>
          <div style="display: inline-table; margin-top: 3px; margin-left: 5px;">
            <a href="#" class="btn btn-link btn-outline-white py-0 skin nux-bgcolor" v-on:click="toggleVisibility();" style="color:inherit;">{{$t('ok_got_it')}}</a>
            <a href="#" class="btn btn-link btn-outline-white ml-1 py-0 skin nux-bgcolor" v-on:click="removeHelpText();" style="color: inherit;">{{$t('stop_showing')}}</a>
          </div>
        </div>
        <div v-show="selectedItem.expanded == true" v-for="menuItem in selectedItem.Children" class="col-4 mobile-nav-submenuitem  text-center my-1">
          <a class="mobile-nav-submenuitem mobile-nav-submenubutton btn btn-link" href="#" @click="redirect(menuItem.Url)">
            <i v-if="menuItem.IconClass != null" v-bind:class="menuItem.IconClass"></i>
            <div v-html="menuItem.Name"></div>
          </a>
        </div>
        <div class="col-1 p-2" v-show="selectedItem.expanded == false && (display == true && getDisplayMessage() != null)" style="float:left;">
          <div class="row">
            <div class="col">
              <help-icon style="float:right"></help-icon>
            </div>
          </div>
        </div>
      </div>

    </div>
    <div class="row mobile-nav-bar skin custom-mobile-menu" v-if="items.length > 0 && menuVisible == true" ref="container" style="height:65px">
      <div class="" v-for="el in items" v-bind:style="getCustomWidth()">

        <!--Standard menu buttons-->
        <button type="button" class="btn btn-block btn-trans btn-float m-0 custom-mobile-menu" v-if="el.Children.length == 0 && permissionlevel >= el.PermissionLevel" style="background-color:none;padding-left:0px;padding-right:0px;z-index:100">
          <a v-if="el.Url == 'Camera'" class="mobile-nav-button" v-bind:class="{'selected':isExpanded(el)}">
              <input-camera></input-camera>
            <span>{{el.Name}}</span>
          </a>
          <a v-else v-bind:href="el.Url" class="mobile-nav-button" @touchstart="toggleSelect(el)" v-bind:class="{'selected':isSelected(el)}">
            <span v-if="el.Url.indexOf('news') > 0" id="newslablebadge" class="newsnotification badge badge-primary badge-pill float-right" style="top: -10px; display: none; position: absolute; z-index: 10000; right: 10px"></span>

            <span v-if="el.Url.indexOf('todo') > 0" id="procedurelablebadge" class="todonotification badge badge-primary badge-pill float-right" style="top: -10px; display: none; position: absolute; z-index: 10000; right: 10px"></span>

            <span v-if="el.Url.indexOf('forum') > 0" id="lablebadge" class="forumnotification badge badge-primary badge-pill float-right" style="top: -10px; display: none; position: absolute; z-index: 10000; right: 10px "></span>
            <span v-if="el.Url.indexOf('forum') > 0" id="lablebadge" class="forumtagsnotification badge badge-warning badge-pill float-right" style="top: -10px; display: none; position: absolute; z-index: 10000; right: 10px "></span>
            <span v-if="el.Url.indexOf('forum') > 0" id="lablebadgeUserTag" class="forumfavouritesnotification badge badge-success badge-pill float-right" style="top: -10px; display: none; position: absolute; z-index: 10000; right: 34px; background-color: #f54646; "></span>
            
            <span v-if="el.Url.indexOf('documents') > 0" class="documentnotification badge badge-primary badge-pill float-right" style="top: -10px; display: none; position: absolute; z-index: 10000; right: 10px; padding-left:.4375rem;padding-right:.4375rem;"></span>
            <i v-if="el.IconClass != null" v-bind:class="el.IconClass"></i>
            <span v-if="el.Name != null">{{el.Name}}</span>
          </a>
        </button>

        

        <button type="button" class="btn btn-block btn-float btn-trans m-0" style="height: 100%; z-index: 100" v-if="el.Children.length > 0 && permissionlevel >= el.PermissionLevel">
          <a v-if="el.Url.indexOf('Profile') > 0" class="mobile-nav-button" @click="toggleExpand(el)" v-bind:class="{'selected':isExpanded(el)}">
            <img v-bind:src="'/api/membership/GetSquareImage?username=' + el.ImageUrl" height="27" width="27" class="rounded-circle" alt="" style="margin-bottom:4px;">
            <div class="profileimage" v-bind:class="{'selected':el.expanded == true}">{{el.Name}}</div>
          </a>

          <!--profile-->
          <a v-if="el.Url.indexOf('Profile') > 0" class="mobile-nav-button" @click="toggleExpand(el)" v-bind:class="{'selected':isExpanded(el)}">
            <img v-bind:src="'/api/membership/GetSquareImage?username=' + el.ImageUrl" height="27" width="27" class="rounded-circle" alt="" style="margin-bottom:4px;">
            <div class="profileimage" v-bind:class="{'selected':el.expanded == true}">{{el.Name}}</div>
          </a>

          <!--more-->
          <span v-if="el.Name == '' && $store.getInstallationType() == 'Education'" class="filenotification badge badge-primary badge-pill float-right" style="top: -10px; display: none; position: absolute; z-index: 10000; right: 10px; padding: .3125rem .4375rem;"></span>

          <a v-if="el.Name == ''" class="mobile-nav-button" @click="toggleExpand(el)" v-bind:class="{'selected':isExpanded(el)}">
            <i class="icon-arrow-up32 icon" v-show="isExpanded(el)"></i>
            <i class="icon-arrow-down32 icon" v-show="!isExpanded(el)"></i>
            <span>{{el.Name}}</span>
          </a>

        </button>
      </div>
    </div>
    <div v-show="static == false" class="row" style="background-color:black;color:white;">
      <a href="#" @click="toggleMenuVisibility" style="color:inherit;width:100%">
        <div class="col-12 text-center" style="width:100%;height:30px;background-color: black;">
          <i class="icon-arrow-down32" v-if="menuVisible == true" style="line-height:30px;margin-bottom:15px;"></i>
          <i class="icon-arrow-up32" v-if="menuVisible == false" style="line-height:30px;margin-bottom:15px;"></i>
        </div>
      </a>
    </div>
    <login-select-site ref="selectSite"></login-select-site>
  </div>
</template>

<script>
  import SelectSite from "../login/login-select-site.vue";
  var url = "";
  var message = null;
  var items = [];
  var selectedItem = {
    expanded: false,
    Children: [],
    Name: null
  };

  var permissionlevel = 0;

  import { TimelineLite } from 'gsap'
  import { gsap } from 'gsap';


  export default {
    name: "mobile-menu",
    components: {
      TimelineLite,
      gsap,
      SelectSite
    },
    props: {
      static: {
        required: false,
        type: Boolean,
        default: false
      },
    },
    data() {
      return {
        items,
        message,
        selectedItem,
        display: false,
        showing: true,
        permissionlevel,
        menuVisible: true,
        sites:[],
      };
    },

    methods: {
      getCustomWidth() {
        if (this.$store.getInstallationType() == "Education") {
          return "width:20%;";
        }
        return "width:16.5%;";
      },
      async getUserSites() {
        var this_context = this;
        try {
          this.$http.get('/api/Authentications/v1/User/Sites').then(async response => {
            var resp = response.data;
            if (resp != null && resp.Sites != null && resp.Sites.length > 1) {
              this_context.sites = resp.Sites;
              var count = 4;
              if (this.$store.getInstallationType() != 'Education') {
                count = 5;
              }
              this.items[count].Children.push({
                "Children": [],
                "Id": 0,
                "Url": "workspace",
                "Name": this.$t('menu_switch_workspace'),
                "IconClass": "icon-exit3",
                "CssClass": null,
                "ImageUrl": null,
                "ActiveImageUrl": null,
                "PermissionLevel": 1
              });
            } 
          });
        }
        catch (err) {          
          alert('some error:' + err);
        }
      },
      redirect(url) {
        switch (url) {
          case "workspace":
            this.$refs.selectSite.setSites(this.sites);
            this.$refs.selectSite.open();
            break;
          default:
            location.href = url;
            break;
        }
      },
      toggleMenuVisibility() {
        this.$store.setMenuVisible(!this.menuVisible);
        this.menuVisible = !this.menuVisible;
        this.$forceUpdate();
      },
      getSelectedItemClass(selectedItem) {
        var str = selectedItem.CssClass;
        if (selectedItem.expanded == true)
          str += " mobilemenu-bgcolor";
        else
          str += " nux-bgcolor";
        return str;
      },
      removeHelpText() {
        setCookie("disablehelptext", true, 999, this.$store.getUsername());
        this.display = false;
      },
      HideFixed() {
        //this.hide(2000);
      },
      hide(timeout = 2000) {
        if (this.static == true)
          return;

        var thisContext = this;
        if (this.showing == false)
          return;

        setTimeout(function () {
          const timeline2 = new TimelineLite({ paused: true })
          timeline2.set(thisContext.$refs["container"], { height: '65px' }, 'start');
          timeline2.from(thisContext.$refs["container"], 0.7, { height: "65px", ease: "none" }, 'start+=0.001')
          timeline2.to(thisContext.$refs["container"], { height: "0px", ease: "none" });
          thisContext.showing = false;
          timeline2.resume();
          if (thisContext.selectedItem != null)
            thisContext.selectedItem.expanded = false;
        }, timeout)

      },
      show(timeout = 5000) {
        var thisContext = this;
        if (this.showing == true)
          return;
        this.showing = true;
        setTimeout(function () {
          const timeline2 = new TimelineLite({ paused: true })
          timeline2.set(thisContext.$refs["container"], { height: '0px' }, 'start');
          timeline2.from(thisContext.$refs["container"], { height: "0px", ease: "none" });
          timeline2.to(thisContext.$refs["container"], { ease: "none", duration: 0.2, height: "65px" })
          timeline2.resume();
          //thisContext.hide(timeout);
        }, 1)

      },
      getDisplayMessage() {
        if (this.message != null && this.message != "" && typeof (this.message) != "undefined") {
          return this.message;
        }
        return null;
      },
      toggleVisibility() {
        this.display = !this.display;
      },
      switchMessage(message) {
        this.message = message;
        this.$forceUpdate();
      },
      isExpanded(el) {
        return el.expanded == true;
      },
      isSelected(el) {
        return location.href.indexOf(el.Url) > -1;
      },
      toggleSelect(el) {
        this.selectedItem = el;
      },
      toggleExpand(el) {
        if (this.selectedItem != el) {
          this.selectedItem.expanded = false; //reset the old one
          el.expanded = true;
          Vue.set(this, "selectedItem", el)
        }
        else {
          Vue.set(this.selectedItem, "expanded", !this.selectedItem.expanded)
        }
        Vue.set(this, "items", this.items);
        this.$forceUpdate();
      },
      loadMenuData() {
        var user = this.$store.getUsername();
        var tmpItems = null;
        if (user == null || user == "") {
          tmpItems = this.getExternalMenu();
        }
        else {

          if (this.$store.getInstallationType() == "Education") {
            tmpItems = this.getEducationLoggedInMenu(user);
          }
          else
            tmpItems = this.getLoggedInMenu(user);



          var locationLowerCase = window.location.href.toLowerCase();

          for (var i = 0; i < tmpItems.length; i++) {

            if (tmpItems[i].Url != null && locationLowerCase.indexOf(tmpItems[i].Url) > -1) {
              this.selectedItem = tmpItems[i];
              Vue.set(this, "selectedItem", tmpItems[i])
            }
            else {
              // Go through the child items
              for (var k = 0; k < tmpItems[i].Children.length; k++) {
                tmpItems[i].expanded = false;
                if (tmpItems[i].Children[k].Url != null && locationLowerCase.indexOf(tmpItems[i].Children[k].Url) > -1) {
                  this.selectedItem = tmpItems[i];
                  Vue.set(this, "selectedItem", tmpItems[i])
                }
              }
            }
          }

        }

        this.items = tmpItems;
        if (this.$store.isLoggedIn() == true) {
          this.getUserSites();
        }
        this.$forceUpdate();

      },

      getEducationLoggedInMenu(username) {        
        var rootUrl = location.pathname;
        var arr = rootUrl.split("/");
        if (rootUrl.endsWith('/')) {
          arr.pop();
        }
        arr.pop(); // remove the actual page we are in;
        rootUrl = arr.join("/");

        var menuItems = [
          {
            "Children": [],
            "Id": 0,
            "Url": rootUrl + "/news",
            "Name": this.$t('menu_news'),
            "IconClass": "icon-home5 icon",
            "CssClass": "element_1",
            "ImageUrl": null,
            "ActiveImageUrl": null,
            "PermissionLevel": 2,
            expanded: false
          },
          {
            "Children": [],
            "Id": 0,
            "Url": rootUrl + "/todo",
            "Name": this.$t('menu_todo'),
            "IconClass": "icon-stack-check icon",
            "CssClass": "element_2",
            "ImageUrl": null,
            "ActiveImageUrl": null,
            "PermissionLevel": 1,
            expanded: false
          },
          {
            "Children": [],
            "Id": 0,
            "Url": rootUrl + "/forum",
            "Name": this.$t('menu_chat'),
            "IconClass": "icon-bubbles9 icon",
            "CssClass": "element_3",
            "ImageUrl": null,
            "ActiveImageUrl": null,
            "PermissionLevel": 2,
            expanded: false
          },




        ];


        if (this.permissionlevel > 2) {

          menuItems.push({
            "Children": [],
            "Id": 0,
            "Url": rootUrl + "/calender",
            "Name": this.$store.translate('menu_calender'),
            "IconClass": "icon-calendar2  icon",
            "CssClass": "element_4",
            "ImageUrl": null,
            "ActiveImageUrl": null,
            "PermissionLevel": 2,
            expanded: false
          })

          menuItems.push({
            "Children": [],
            "Id": 0,
            "Url": "",
            "Name": "",
            "IconClass": null,
            "CssClass": "element_5",
            "ImageUrl": null,
            "ActiveImageUrl": null,
            "PermissionLevel": 1,
            expanded: false
          })

          menuItems[4].Children.push({
            "Children": [],
            "Id": 0,
            "Url": rootUrl + "/admin",
            "Name": this.$t('menu_admin'),
            "IconClass": "icon-cogs",
            "CssClass": null,
            "ImageUrl": null,
            "ActiveImageUrl": null,
            "PermissionLevel": 5
          });

          /*
          menuItems[4].Children.push({
            "Children": [],
            "Id": 0,
            "Url": rootUrl + "/admin-overview",
            "Name": this.$t('menu_overview'),
            "IconClass": "icon-cogs",
            "CssClass": null,
            "ImageUrl": null,
            "ActiveImageUrl": null,
            "PermissionLevel": 5
          });
          */

          menuItems[4].Children.push({
            "Children": [],
            "Id": 0,
            "Url": rootUrl + "/templates",
            "Name": this.$t('menu_procedures'),
            "IconClass": "icon-stack-check",
            "CssClass": null,
            "ImageUrl": null,
            "ActiveImageUrl": null,
            "PermissionLevel": 4
          });
          menuItems[4].Children.push({
            "Children": [],
            "Id": 0,
            "Url": rootUrl + "/contacts",
            "Name": this.$t('menu_contacts'),
            "IconClass": "icon-users",
            "CssClass": null,
            "ImageUrl": null,
            "ActiveImageUrl": null,
            "PermissionLevel": 4
          });

          menuItems[4].Children.push({
            "Children": [],
            "Id": 0,
            "Url": rootUrl + "/documents",
            "Name": this.$t('menu_documents') + '<span class="filenotification badge badge-primary badge-pill float-right" style="top: -10px; display: none; position: absolute; z-index: 10000; right: 10px; padding-left:.4375rem;padding-right:.4375rem;"></span>',
            "IconClass": "icon-attachment",
            "CssClass": null,
            "ImageUrl": null,
            "ActiveImageUrl": null,
            "PermissionLevel": 2
          });

          menuItems[4].Children.push({
            "Children": [],
            "Id": 0,
            "Url": "javascript:getLoggedUserProfile();",
            "Name": this.$t('menu_update_profile'),
            "IconClass": "icon-user",
            "CssClass": null,
            "ImageUrl": null,
            "ActiveImageUrl": null,
            "PermissionLevel": 2
          });
          menuItems[4].Children.push({
            "Children": [],
            "Id": 0,
            "Url": "javascript:changePasswordPopUp();",
            "Name": this.$t('menu_change_password'),
            "IconClass": "icon-eye",
            "CssClass": null,
            "ImageUrl": null,
            "ActiveImageUrl": null,
            "PermissionLevel": 2
          });

          menuItems[4].Children.push({
            "Children": [],
            "Id": 0,
            "Url": rootUrl + "/Signout",//"/api/Authentication/logout",
            "Name": this.$t('menu_logout'),
            "IconClass": "icon-exit3",
            "CssClass": null,
            "ImageUrl": null,
            "ActiveImageUrl": null,
            "PermissionLevel": 1
          });



        }
        else {

          menuItems.push({
            "Children": [],
            "Id": 0,
            "Url": "javascript:getLoggedUserProfile();",
            "Name": this.$t('menu_update_profile'),
            "IconClass": "icon-user icon",
            "CssClass": null,
            "ImageUrl": null,
            "ActiveImageUrl": null,
            "PermissionLevel": 2
          });
          menuItems.push({
            "Children": [],
            "Id": 0,
            "Url": "javascript:changePasswordPopUp();",
            "Name": this.$t('menu_change_password'),
            "IconClass": "icon-eye",
            "CssClass": null,
            "ImageUrl": null,
            "ActiveImageUrl": null,
            "PermissionLevel": 2
          });

          menuItems.push({
            "Children": [],
            "Id": 0,
            "Url": rootUrl + "/Signout",//"/api/Authentication/logout",
            "Name": this.$t('menu_logout'),
            "IconClass": "icon-exit3 icon",
            "CssClass": null,
            "ImageUrl": null,
            "ActiveImageUrl": null,
            "PermissionLevel": 1
          });
        }




        menuItems = this.arrangeMenu(menuItems)

        return menuItems;
      },
      getLoggedInMenu(username) {        
        var rootUrl = location.pathname;
        var arr = rootUrl.split("/");
        if (rootUrl.endsWith('/')) {
          arr.pop();
        }
        arr.pop(); // remove the actual page we are in;
        rootUrl = arr.join("/");

        //var site = ("/" + this.$store.siteName()).toLowerCase();
        //var locale = "/" + this.$store.getLocale().toLowerCase();
        var menuItems = [
          {
            "Children": [],
            "Id": 0,
            "Url": rootUrl + "/news",
            "Name": this.$t('menu_news'),
            "IconClass": "icon-home5 icon",
            "CssClass": "element_1",
            "ImageUrl": null,
            "ActiveImageUrl": null,
            "PermissionLevel": 2,
            expanded: false
          },
          {
            "Children": [],
            "Id": 0,
            "Url": rootUrl + "/todo",
            "Name": this.$t('menu_todo'),
            "IconClass": "icon-stack-check icon",
            "CssClass": "element_2",
            "ImageUrl": null,
            "ActiveImageUrl": null,
            "PermissionLevel": 1,
            expanded: false
          },
          {
            "Children": [],
            "Id": 0,
            "Url": rootUrl + "/forum",
            "Name": this.$t('menu_chat'),
            "IconClass": "icon-bubbles9 icon",
            "CssClass": "element_3",
            "ImageUrl": null,
            "ActiveImageUrl": null,
            "PermissionLevel": 2,
            expanded: false
          },
          {
            "Children": [],
            "Id": 0,
            "Url": rootUrl + "/calender",
            "Name": this.$store.translate('menu_calender'),
            "IconClass": "icon-calendar2  icon",
            "CssClass": "element_4",
            "ImageUrl": null,
            "ActiveImageUrl": null,
            "PermissionLevel": 2,
            expanded: false
          },
          {
            "Children": [],
            "Id": 0,
            "Url": rootUrl + "/documents",
            "Name": this.$t('menu_documents'), /*+ '<span class="filenotification badge badge-primary badge-pill float-right" style="top: -10px; display: none; position: absolute; z-index: 10000; right: 10px; padding-left:.4375rem;padding-right:.4375rem;"></span>',*/
            "IconClass": "icon-attachment icon",
            "CssClass": "element_5",
            "ImageUrl": null,
            "ActiveImageUrl": null,
            "PermissionLevel": 2,
            expanded: false
          },
          {
            "Children": [],
            "Id": 0,
            "Url": "",
            "Name": "",
            "IconClass": null,
            "CssClass": "element_6",
            "ImageUrl": null,
            "ActiveImageUrl": null,
            "PermissionLevel": 1,
            expanded: false
          }
        ];

        menuItems[5].Children.push({
          "Children": [],
          "Id": 0,
          "Url": rootUrl + "/admin",
          "Name": this.$t('menu_admin'),
          "IconClass": "icon-cogs",
          "CssClass": null,
          "ImageUrl": null,
          "ActiveImageUrl": null,
          "PermissionLevel": 5
        });

        menuItems[5].Children.push({
          "Children": [],
          "Id": 0,
          "Url": rootUrl + "/admin-overview",
          "Name": this.$t('menu_admin_overview'),
          "IconClass": "icon-cogs",
          "CssClass": null,
          "ImageUrl": null,
          "ActiveImageUrl": null,
          "PermissionLevel": 5
        });

        /*
        menuItems[4].Children.push({
          "Children": [],
          "Id": 0,
          "Url": rootUrl + "/admin-overview",
          "Name": this.$t('menu_overview'),
          "IconClass": "icon-cogs",
          "CssClass": null,
          "ImageUrl": null,
          "ActiveImageUrl": null,
          "PermissionLevel": 5
        });
        */

        menuItems[5].Children.push({
          "Children": [],
          "Id": 0,
          "Url": rootUrl + "/templates",
          "Name": this.$t('menu_procedures'),
          "IconClass": "icon-stack-check",
          "CssClass": null,
          "ImageUrl": null,
          "ActiveImageUrl": null,
          "PermissionLevel": 4
        });
        menuItems[5].Children.push({
          "Children": [],
          "Id": 0,
          "Url": rootUrl + "/contacts",
          "Name": this.$t('menu_contacts'),
          "IconClass": "icon-users",
          "CssClass": null,
          "ImageUrl": null,
          "ActiveImageUrl": null,
          "PermissionLevel": 2
        });

        //menuItems[5].Children.push({
        //  "Children": [],
        //  "Id": 0,
        //  "Url": rootUrl + "/documents",
        //  "Name": this.$t('menu_documents') + '<span class="filenotification badge badge-primary badge-pill float-right" style="top: -10px; display: none; position: absolute; z-index: 10000; right: 10px; padding-left:.4375rem;padding-right:.4375rem;"></span>',
        //  "IconClass": "icon-attachment",
        //  "CssClass": null,
        //  "ImageUrl": null,
        //  "ActiveImageUrl": null,
        //  "PermissionLevel": 2
        //});

        menuItems[5].Children.push({
          "Children": [],
          "Id": 0,
          "Url": "javascript:getLoggedUserProfile();",
          "Name": this.$t('menu_update_profile'),
          "IconClass": "icon-user",
          "CssClass": null,
          "ImageUrl": null,
          "ActiveImageUrl": null,
          "PermissionLevel": 2
        });
        menuItems[5].Children.push({
          "Children": [],
          "Id": 0,
          "Url": "javascript:changePasswordPopUp();",
          "Name": this.$t('menu_change_password'),
          "IconClass": "icon-eye",
          "CssClass": null,
          "ImageUrl": null,
          "ActiveImageUrl": null,
          "PermissionLevel": 2
        });
        menuItems[5].Children.push({
          "Children": [],
          "Id": 0,
          "Url": rootUrl + "/Signout",//"/api/Authentication/logout",
          "Name": this.$t('menu_logout'),
          "IconClass": "icon-exit3",
          "CssClass": null,
          "ImageUrl": null,
          "ActiveImageUrl": null,
          "PermissionLevel": 1
        });

        

        menuItems = this.arrangeMenu(menuItems)

        return menuItems;
      },
     
      getExternalMenu() {
        var menuItems = [
          {
            "Children": [], "Id": 0, "Url": "/login", "Name": "Login", "IconClass": "icon-user-lock icon", "CssClass": "element_1", "ImageUrl": null, "ActiveImageUrl": null, "PermissionLevel": 0, expanded: false,
          }
        ];
        return menuItems;
      },
      arrangeMenu(menuItems) {
        var items = [];
        var counter = 1;

        for (var i = 0; i < menuItems.length; i++) {

          if (menuItems[i].PermissionLevel <= this.permissionlevel) {

            menuItems[i].Children = this.arrangeMenu(menuItems[i].Children)
            menuItems[i].CssClass = "element_" + counter;
            items.push(menuItems[i]);
            counter++;
          }
        }
        console.log(items);
        return items;
      }


    },
    computed: {
      isDisplayMessageVisible: {
        get() {
          return this.selectedItem.expanded == false && this.display == true;
        }
      }
    },
    mounted() {

      var disable = getCookie("disablehelptext", this.$store.getUsername())

      this.permissionlevel = this.$store.getUserPermissionLevel();

      if (disable != null && disable != "")
        this.display = false;
      else
        this.display = true;

      //this.$forceUpdate();

      this.loadMenuData();

      this.$root.$on('nux', this.switchMessage);

      //$(window).on("load", this.HideFixed);
      //document.addEventListener('scroll', this.show, true );

      

    },



    created: function () {

    },

    watch: {
      isDisplayMessageVisible(newValue) {
        this.$store.setHelptextVisible(newValue);
      }
    },
    created() {

    },
  };

</script>

<style scoped>

  .custom-center {
    top: 50%;
    -ms-transform: translateY(-50%);
    transform: translateY(-50%);
  }

  .btn-trans {
    background-color: transparent;
    border: none;
  }

  .speech-bubble {
    position: relative;
    background: #cce7ee;
    margin: -10px;
    margin-bottom: 0px;
    color: black !important;
    border-top: 1px solid #aaa !important;
  }

    .speech-bubble:after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 50%;
      width: 0;
      height: 0;
      border: 0.75em solid transparent;
      border-top-color: transparent;
      border-bottom-color: transparent;
      border-bottom-style: solid;
      border-bottom-width: 0.75em;
      border-top-color: #cce7ee;
      border-bottom: 0;
      margin-bottom: -0.75em;
      z-index: 10000;
      padding-top: 1px;
    }

    .speech-bubble.element_1:after {
      margin-left: calc(-40% - 10px)
    }

    .speech-bubble.element_2:after {
      margin-left: calc(-20% - 5px)
    }

    .speech-bubble.element_3:after {
      margin-left: calc(-10px)
    }

    .speech-bubble.element_4:after {
      margin-left: calc(20% - 10px)
    }

    .speech-bubble.element_5:after {
      margin-left: calc(30% - 10px)
    }

    .speech-bubble.element_6:after {
      margin-left: calc(40% - 10px)
    }

  .mobile-nav-submenuitem:focus, .mobile-nav-submenuitem:hover {
    color: black;
  }

  .mobile-nav-submenubutton:active, .mobile-nav-submenubutton:focus {
    color: white !important;
    background-color: #717171 !important;
    width: 100%;
  }

  .mobile-nav-submenuitem {
    color: #293a50;
    width: 100%;
    height: 100%;
  }

  .mobile-nav-button:focus, .mobile-nav-button:hover, .mobile-nav-button.selected, .profileimage.selected {
    color: white !important;
    background-color: transparent;
  }

  .mobile-nav-button.selected {
    color: white !important;
    background-color: transparent;
    font-weight: bolder;
  }

  .custom-mobile-menu.selected .icon {
    font-weight: bolder;
  }

  .mobile-nav-button:hover {
    box-shadow: 0 0 0 62.5rem rgba(0,0,0,.075) inset;
  }

  .mobile-nav-button {
    color: #ccc;
  }

  .mobile-nav-bar {
    color: #ccc;
    /*background-color: #293a50 !important;*/
  }

  .mobile-nux-leftarrow {
    width: 5%;
    float: left;
  }

  .mobile-nux-center {
    width: 80%;
    margin-left: 5px;
    float: left;
    text-align: center;
  }

  .mobile-nux-rightarrow {
    width: 5%;
    float: right;
  }

  .custom-mobile-menu {
    font-size: 10px;
  }

    .custom-mobile-menu .icon {
      font-size: 1.5rem;
    }
</style>





// WEBPACK FOOTER //
// src/components/navigation/mobile-menu.vue